import { Item, ItemType, ItemTypeTopic } from 'src/graphql/types'

export default function (item: Item): string | undefined {

  switch (item.type) {
    case ItemType.Folder:
      return 'folder-outline'
    case ItemType.Course:
      return 'school-outline'
    case ItemType.Topic:
      switch (item.typeTopic) {
        case ItemTypeTopic.Keynote:
          return 'albums-outline'
        case ItemTypeTopic.Quiz:
          return 'checkmark-done-outline'
      }
  }
}
